import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Header from './Header';
import { apiBaseURL, apiURL, apiKey, ckFinderURL } from '../../constant';
import Swal from "sweetalert2";

const AddSubject = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        subjectName: '',
        subjectAbbreviation: '',
        subjectPrice: '',
        examDuration: '',
        subjectSequence: '',
        sectionID: '',
        createdDate: '',
    });
    const [subjects, setSubjects] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        fetchSubjects();
        fetchChapters();
    }, []);
    const fetchSubjects = async () => {
        try {
            const response = await fetch(apiBaseURL + apiURL.getSubjects, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                }
            });
            const result = await response.json();
            if (result.status === 1) {
                setSubjects(result.data);
            } else {
                setSubjects([]);
            }
        } catch (error) {
            console.error("Error fetching subjects:", error);
            setSubjects([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchChapters = async () => {
        try {
            const response = await fetch(apiBaseURL + apiURL.getChapters, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                }
            });
            const result = await response.json();
            if (result.status === 1) {
                setChapters(result.data);
            } else {
                setChapters([]);
            }
        } catch (error) {
            console.error("Error fetching chapters:", error);
            setChapters([]);
        } finally {
            setLoading(false);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { chapterID, chapterNumber, chapterName, classID, subjectID, sectionID, chapterSequence, } = formData;
        const data = {
            chapterID, chapterNumber, chapterName, classID, subjectID, sectionID, chapterSequence,
        };
        console.log("API Data:", data);
        try {
            const url = chapterID ? apiBaseURL + `/updateChapter` : apiBaseURL + `/addChapter`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify(data)
            });
            const result = await response.json();
            console.log("API Response:", result);
            if (result.status === 1) {
                //alert(result.message);
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: result.message,
                    confirmButtonText: "OK",
                });
                handleReset();
                fetchChapters();
            } else {
                //alert(result.message || "Something went wrong");
                Swal.fire({
                    icon: "error",
                    title: "Oops! ",
                    text: result.message,
                    confirmButtonText: "OK",
                });
            }

        }
        catch (error) {
            console.error("API Error:", error);
            // alert("Something went wrong. Please try again.");
            Swal.fire({
                icon: "error",
                title: "Something went wrong. Please try again.",
                confirmButtonText: "OK",
            });
        }
    };

    const handleReset = () => {
        setFormData({
            chapterID: "",
            chapterNumber: '',
            chapterName: '',
            classID: '',
            subjectID: '',
            sectionID: '',
            chapterSequence: '',
        });
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!formData.subjectid) {
            Swal.fire({
                icon: "error",
                title: "Please select subject",
                confirmButtonText: "OK",
            });
            return;
        }
        try {
            setLoading(true);
            const response = await fetch(apiBaseURL + `/getChapters?subjectID=${formData.subjectid}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "key": apiKey
                    },
                }
            );
            const result = await response.json();
            if (result.status === 1) {
                setChapters(result.data);
            } else {
                setChapters([]);
            }
        } catch (error) {
            console.error("Error fetching chapters:", error);
            setChapters([]);
        } finally {
            setLoading(false);
        }
    };
    const handleReload = () => {
        window.location.reload();
    };
    const handleEdit = (chapter) => {
        setFormData({
            chapterID: chapter.chapterID,
            sectionID: chapter.sectionID,
            chapterName: chapter.chapterName,
            chapterNumber: chapter.chapterNumber,
            subjectID: chapter.subjectID,
            classID: chapter.classID,
            chapterSequence: chapter.chapterSequence,
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const handleDelete = async (chapterID) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this chapter?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });
        if (!result.isConfirmed) {
            return;
        }
        try {
            const response = await fetch(apiBaseURL + "/deleteChapter", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify({
                    chapterID: chapterID
                })
            });
            const result = await response.json();
            console.log("Delete Response:", result);
            if (result.status === 1) {
                //alert(result.message);
                Swal.fire({
                    icon: "error",
                    title: "Deleted! ",
                    text: result.message,
                    confirmButtonText: "OK",
                });
                fetchChapters();
            } else {
                // alert(result.message || "Unable to delete chapter");
                Swal.fire({
                    icon: "error",
                    title: "Unable to delete chapter! ",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Delete Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    const filteredSubjects = subjects.filter((subject) => {
        if (formData.sectionID === "1") {
            return subject.subjectName.toLowerCase() === "english";
        }

        if (formData.sectionID === "2") {
            return subject.subjectName.toLowerCase() !== "english";
        }

        return false;
    });

    return (
        <>
            <Header />
            <div className="container-fluid px-3 px-md-4 py-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '12px' }}>
                    <div><h4 className="mb-1">Add Chapter</h4><small className="text-muted">Add a new chapter for the subject</small></div>
                    <button type="button" className="btn btn-outline-secondary mt-2 mt-md-0" onClick={() => navigate(-1)}><ArrowBackIcon style={{ fontSize: '18px', marginRight: '5px' }} />Back</button>
                </div>

                <div className="card shadow-sm">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Select Section <span className="text-danger">*</span></label>
                                    <select name="sectionID" className="form-select" value={formData.sectionID} onChange={handleChange} required >
                                        <option value="">~Select~</option>
                                        <option value="1">English</option>
                                        <option value="2">Domain Specific Subjects</option>
                                    </select>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Select Subject <span className="text-danger">*</span></label>
                                    <select name="subjectID" className="form-select" value={formData.subjectID} onChange={handleChange} required disabled={!formData.sectionID} >
                                        <option value="">~Select~</option>
                                        {filteredSubjects.map((subject) => (
                                            <option key={subject.subjectID} value={subject.subjectID} >
                                                {subject.subjectName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Chapter Name <span className="text-danger">*</span></label>
                                    <input type="text" name="chapterName" className="form-control" value={formData.chapterName} onChange={handleChange} required />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Chapter No.</label>
                                    <input type="text" name="chapterNumber" className="form-control" value={formData.chapterNumber} onChange={handleChange} />
                                </div>

                                {/* <div className="col-md-2 mb-3">
                                    <label className="form-label">Class <span className="text-danger">*</span></label>
                                    <select name="classID" className="form-select" value={formData.classID} onChange={handleChange} required>
                                        <option value="">~Select~</option>
                                        <option value="12">12</option>
                                        <option value="10">10</option>
                                    </select>
                                </div> */}

                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Chapter Sequence</label>
                                    <input type="text" name="chapterSequence" className="form-control" value={formData.chapterSequence} onChange={handleChange} required />
                                </div>
                            </div>

                            <div className="d-flex flex-wrap gap-2 mt-3" style={{ borderTop: '1px solid #dee2e6', paddingTop: '15px' }}>
                                {/* <button type="submit" className="btn btn-primary"><SaveIcon style={{ fontSize: '18px', marginRight: '5px' }} />Save</button> */}
                                <button type="submit" className="btn btn-primary"><i className="fa fa-save"></i> {formData.chapterID ? "Update" : "Save"}
                                </button>
                                <button type="reset" className="btn btn-outline-secondary" onClick={handleReset}><RestartAltIcon style={{ fontSize: '18px', marginRight: '5px' }} />Reset</button>
                                <button type="button" className="btn btn-outline-danger" onClick={() => navigate(-1)}>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
                <p className='searchingBlock'>
                    <form onSubmit={handleSearch}>
                        <div className="row">
                            <div className="col-md-4 mt-3">
                                <select name="subjectid" className="form-select" onChange={handleChange} required>
                                    <option value="">~Select Subject~</option>
                                    {subjects.length > 0 &&
                                        subjects.map((subject) => (
                                            <option key={subject.subjectID} value={subject.subjectID}>
                                                {subject.subjectName}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-md-2 mt-3">
                                <button type="submit" className="btn btn-primary"><i className='fa fa-search'></i> Search</button>
                                &nbsp; <button type="button" className="btn btn-warning" onClick={handleReload}><i className='fa fa-refresh'></i> Reload</button>
                            </div>
                        </div>
                    </form>
                </p>
                <div className="row">
                    <div className="col-md-12 mt-3">
                        <div className='chapterData' style={{ "font-size": "15px", "height": "40vh", "overflow-y": "scroll" }}>
                            <table className="table table-bordered table-striped" style={{ "font-size": "15px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ background: "#251e1e", color: "#fff" }}>S.N</th>
                                        <th style={{ background: "#251e1e", color: "#fff" }}>Chapter No</th>
                                        <th style={{ background: "#251e1e", color: "#fff" }}>Chapter Name</th>
                                        <th style={{ background: "#251e1e", color: "#fff" }}>Sequence</th>
                                        <th style={{ background: "#251e1e", color: "#fff" }}>Subject Name</th>
                                        <th style={{ background: "#251e1e", color: "#fff" }}>Created On</th>
                                        <th style={{ background: "#251e1e", color: "#fff" }} className='text-center'>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {chapters.length > 0 ? (chapters.map((chapter, index) => (
                                        <tr key={chapter.chapterID}>
                                            <td>{index + 1}</td>
                                            <td>{chapter.chapterNumber}</td>
                                            <td>{chapter.chapterName}</td>
                                            <td>{chapter.chapterSequence}</td>
                                            <td>{chapter.getSubject?.subjectName}</td>
                                            <td>{chapter.createdDate
                                                ? new Date(chapter.createdDate).toLocaleString('en-IN', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })
                                                : '-'
                                            }</td>
                                            <td className='text-center'>
                                                <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(chapter)}>
                                                    <i className="fa fa-edit"></i>
                                                </button>
                                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(chapter.chapterID)}>
                                                    <i className="fa fa-close"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                {loading ? "Loading..." : "No chapters found."}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

            </div >
        </>
    );
};

export default AddSubject;
